// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  domain: "",
  apiUrl: "https://qafelat.com:3000",
  socketUrl: "https://qafelat.com:8087",
  googleapiKey: "AIzaSyCdz0HAfYm6z9oMUTEbxyxjvPHeC-KinYk",
  googleloginClientid:
    "562680792973-c1lnj37uh3cg1lfv9kpvpo0vvmuamsoa.apps.googleusercontent.com",
  facebookloginClientid: "",
  firebase: {
    apiKey: "AIzaSyAuZkuPYFhX99nuVSXMHQiI5aHDrLmgh80",
    authDomain: "qafelat.firebaseapp.com",
    databaseURL: "https://qafelat-default-rtdb.firebaseio.com",
    projectId: "qafelat",
    storageBucket: "qafelat.firebasestorage.app",
    messagingSenderId: "562680792973",
    appId: "1:562680792973:web:0bbdaf6f8a98ab7c3b9fc4",
  },
};
